(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ReserveLimitsListController', ReserveLimitsListController);

    ReserveLimitsListController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService', 'ReserveLimit', 'ReserveLimitCustom', 'pagingParams', 'paginationConstants', '$mdDialog', 'Principal', 'DialogService'];

    function ReserveLimitsListController($scope, $state, ParseLinks, AlertService, ReserveLimit, ReserveLimitCustom, pagingParams, paginationConstants, $mdDialog, Principal, DialogService) {

        var vm = this;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;

        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.newReserveLimitClick = newReserveLimitClick;

        vm.editReserveLimit = editReserveLimit;
        vm.searchKeyPress = searchKeyPress;
        vm.newReserveLimit = newReserveLimit;
        vm.clearSearch = clearSearch;

        loadAll_paging();

        function loadAll_paging() {


            if (pagingParams.search) {
                ReserveLimitCustom.getAllCompanyReserveLimits().query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ReserveLimitCustom.getAllCompanyReserveLimits().query({
                    query: "",
                    page: pagingParams.page - 1,
                    size: paginationConstants.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {

                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.reserveLimits = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function search() {
            if (vm.searchQuery) {
                loadAll_paging();
                vm.links = null;
                vm.page = 1;
                vm.predicate = '_score';
                vm.reverse = false;
                vm.currentSearch = vm.searchQuery;
                vm.transition();
            }
        }

        function newReserveLimitClick() {

            var result;

            result = Principal.hasSpecialFeatureAccess("reserveLimit");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }

            $state.transitionTo('supplierPanel.newReserveLimit');

        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                search();
            }
        }

        function editReserveLimit(servant) {
            $state.go('supplierPanel-v2.editReserveLimit', {id: servant.id});
        }

        function newReserveLimit() {
            var result;

            result = Principal.hasSpecialFeatureAccess("reserveLimit");
            if (!result) {
                DialogService.showAlert("عدم دسترسی", "برای اضافه کردن نیاز به ارتقای پکیج خود دارید");
                return;
            }
            $state.go('supplierPanel-v2.newReserveLimit');
        }

        function clearSearch() {
            vm.searchQuery = null;
            search();
        }

    }
})();
